export const dropDownItems = [
  {
    title: "Cambiar de cuenta",
    imageURL: "/images/Profile.svg",
    submenu: [
      {
        title: "Mi Perfil",
        link: "/Cuenta",
      },
      {
        title: "Cerrar sesión",
        link: "/",
      }
    ],
  },
];
